import React from 'react';

import DateUtils from 'toolkit/DateUtils';
import TimezoneUtils from 'toolkit/TimezoneUtils';

import styles from './index.module.scss';

const getEndDateTime = (timezone?: string | null): number => {
  if (timezone) {
    return TimezoneUtils.getEndDateWithTimezone(timezone).getTime();
  }

  return DateUtils.END_TODAY.getTime();
};

const isDaySelected = (date?: Date | null, startDate?: Date | null): boolean => {
  if (date && startDate) {
    const beginDate = DateUtils.getStartOfDay(date);
    const beginStartDate = DateUtils.getStartOfDay(startDate);
    return beginDate.getTime() === beginStartDate.getTime();
  }

  return date?.getTime() === startDate?.getTime();
};

export const getRenderDayContents =
  (
    elementId: string,
    startDate: Date | null,
    minDate: Date | null,
    showPreviousMonths: boolean,
    timezone?: string | null
  ) =>
  (day: number, date: Date | undefined) => {
    const dateTime = date?.getTime() || 0;
    const minDateTime = minDate?.getTime() || 0;
    const isSelected = isDaySelected(date, startDate);

    return (
      <div
        className={styles.DatePickerDay}
        data-selected={isSelected}
        data-disabled={
          showPreviousMonths ? dateTime > getEndDateTime(timezone) || minDateTime > dateTime : minDateTime > dateTime
        }
        id={`${elementId}_${isSelected ? 'selected' : ''}`}>
        {day}
      </div>
    );
  };

export const getRenderDayRangeContents =
  (startDate: Date | null, endDate: Date | null, elementId?: string) => (day: number, date: Date | undefined) => {
    if (!date) return <div className={styles.DatePickerDay}>{day}</div>;

    const dateTime = date?.getTime() || 0;
    const startDateTime = startDate?.getTime() || 0;
    const endDateTime = endDate?.getTime() || 0;

    const isStartDate = isDaySelected(date, startDate);
    const isEndDate = isDaySelected(date, endDate);
    const isInRange = startDateTime && endDateTime && dateTime > startDateTime && dateTime < endDateTime;
    const isSelected = isStartDate || isEndDate;
    const isToday = DateUtils.getStartOfDay(date).getTime() === DateUtils.START_TODAY.getTime();

    return (
      <div
        className={styles.DatePickerDay}
        data-selected={isSelected}
        data-range={isInRange}
        data-start={isStartDate}
        data-end={isEndDate}
        id={isToday && elementId ? `${elementId}_today` : undefined}>
        {day}
      </div>
    );
  };
